import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "../../api/baseApi";
import { MovieDetails } from "../../../types/movies";
import EmptyResults from "./components/EmptyResults";
import Results from "./components/Results";
import { useDebounce } from "../../hooks/useDebounce";

function SearchPage() {
  const [searchResults, setSearchResults] = useState<Partial<MovieDetails>[]>(
    []
  );
  const searchUrl = "/search/multi?include_adult=false&query=";
  const searchTerm = new URLSearchParams(useLocation().search).get(
    "q"
  ) as string;
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  useEffect(() => {
    if (debouncedSearchTerm) fetchSearchMovie(debouncedSearchTerm);
  }, [debouncedSearchTerm]);

  const fetchSearchMovie = async (searchTerm: string) => {
    try {
      const { data } = await axios.get(searchUrl + searchTerm);
      setSearchResults(data.results);
    } catch (error) {
      console.log(error, "error");
    }
  };

  return searchResults.length > 0 ? (
    <Results searchResults={searchResults} />
  ) : (
    <EmptyResults searchTerm={searchTerm} />
  );
}

export default SearchPage;
